let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2Fu3d")).then(() => parcelRequire('15Tdz'));